export const dateFormat = (date: string) => {
  const cloneDate = new Date(date)
  const year = cloneDate.getFullYear()
  const month = cloneDate.getMonth()+1
  const day = cloneDate.getDate()

  return year + '年' + month + '月' + day + '日'
}

export const filterEmpty = (obj: any) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined && value !== '')
  );
}


export const getTopicAndProductTags = (tags: string, cateTags: any[], productTags: any[]) => {
  if (!tags) return [[], []];
  const tagArray = tags.split(' ');
  
  const cateTagList = cateTags.map((cateTag: any) => cateTag.topics).flat().map((item: any) => ({
    uid: item.uid,
    url: item?.url,
  }));
  
  const productTagList = productTags.map((productTag: any) => ({
    uid: productTag.uid,
    url: productTag?.url,
  }));
  const filterCateTags = cateTagList.filter((cateTag: any) => tagArray.includes(cateTag?.url)).map((cateTag: any) => cateTag.uid);
  const filterProductTags = productTagList.filter((productTag: any) => tagArray.includes(productTag?.url)).map((productTag: any) => productTag.uid);
  
  return [filterCateTags, filterProductTags];
}



export function filterSvgPath(asPath: string | undefined) {
  return asPath ? asPath?.includes('.svg') || asPath?.includes('.png') : false;
}
